// extracted by mini-css-extract-plugin
export var features = "features-module--features--2PM4_";